/* eslint-disable react-hooks/exhaustive-deps */
import { KTSVG } from '../../_metronic/helpers'
import React, { useState, useEffect, useRef } from 'react'
import { Table } from 'react-bootstrap-v5';
import Swal from 'sweetalert2'
import { getRequestOptions, postRequestOptions } from '../helpers/Fetchwrapper'
import Select from 'react-select'
import { useParams } from 'react-router-dom'
import { Link } from 'react-router-dom';
import validationErrorMsg from '../helpers/ValidationErrorMsg'
import { useHistory } from "react-router-dom";
import Accordion from 'react-bootstrap/Accordion';
import PurchaseOrderItemsSection, { PurchaseOrderRow, ChargeType, ChargeName, ChargeChange, applyChargeChange, resolveChargeAmount } from '../components/PurchaseOrderItemsSection'

interface PurchaseData {
    idPo?: number;
    purchaseType: string;
    purpose: string;
    idProjects: number;
    idVendors: number;
    purchaseDate: string;
    lcNo: string;
    piNo: string;
    representativeName: string;
    representativePhone: string;
    receivingAddress: string;
    totalAmount: number;
    totalDiscountAmount: number;
    totalCarryingCost: number;
    totalAmountAfterDiscount: number;
    vatPercentage: number;
    vatAmount: number;
    taxPercentage: number;
    taxAmount: number;
    vatType: ChargeType;
    taxType: ChargeType;
    purchaseAmount: number;
    creditDays: number;
    referenceNo: string;
}

interface TermsAndCondition {
    termsConditionDetails: string;
    [key: string]: any; // Index signature
}

interface RouteParams {
    idPo: string;
}

const PurchaseOrderEdit = () => {

    let history = useHistory();
    const { idPo }: RouteParams = useParams();

    const purchaseData: PurchaseData = {
        idPo: parseInt(idPo),
        purchaseType: "PO",
        purpose: "Raw Materials",
        idProjects: 0,
        idVendors: 0,
        purchaseDate: '',
        lcNo: '',
        piNo: '',
        representativeName: '',
        representativePhone: '',
        receivingAddress: '',
        creditDays: 0,
        totalAmount: 0,
        totalDiscountAmount: 0,
        totalCarryingCost: 0,
        totalAmountAfterDiscount: 0,
        vatPercentage: 0,
        vatAmount: 0,
        taxPercentage: 0,
        taxAmount: 0,
        vatType: 'percentage',
        taxType: 'percentage',
        purchaseAmount: 0,
        referenceNo: ''
    };

    const [projects, setProjects] = useState([]);
    const [project, setProject] = useState({ label: 'Select Project', value: '' });
    const [vendors, setVendors] = useState([]);
    const [vendor, setVendor] = useState({ label: 'Select Vendor', value: '' });
    let [purchase, setPurchase] = useState(purchaseData);
    const [purchaseRows, setPurchaseRows] = useState<PurchaseOrderRow[]>([{
        idPoRows: 0,
        idItems: 0,
        idProducts: 0,
        quantity: 0,
        excludingRate: 0,
        amount: 0,
        discountAmount: 0,
        carryingCost: 0,
        totalAmount: 0,
        rate: 0,
    }]);

    const [termsAndConditions, setTermsAndConditions] = useState<TermsAndCondition[]>([]);
    const isCalculatingRef = useRef(false);
    const isInitialLoadRef = useRef(false);

    useEffect(() => {
        getProjects();
        getVendors();

        if (idPo !== undefined) {
            getPurchaseInfo();
        }
    }, [idPo])

    // Recalculate summary when purchaseRows change (but skip if we're already calculating or initial load)
    useEffect(() => {
        if (isCalculatingRef.current || isInitialLoadRef.current) {
            if (isCalculatingRef.current) {
                isCalculatingRef.current = false;
            }
            return;
        }
        if (purchaseRows.length > 0) {
            const hasData = purchaseRows.some(row => row.idItems > 0 || row.idProducts > 0 || row.quantity > 0 || row.excludingRate > 0);
            if (hasData) {
                calculateSummary();
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [purchaseRows])


    const getProjects = () => {
        fetch(
            process.env.REACT_APP_API_URL + 'lead/projects',
            getRequestOptions()
        )
            .then((resp) => {
                return resp.json()
            })
            .then((resp) => {
                let projectObj = resp.data.map((item: any) => {
                    item.label = item.name;
                    item.value = item.id;
                    return item
                })
                setProjects(projectObj);
            })
            .catch((error) => {
                console.log(error, 'catch the hoop')
            })
    }

    const getVendors = () => {

        fetch(
            process.env.REACT_APP_API_URL + 'vendors',
            getRequestOptions()
        )
            .then((resp) => {
                return resp.json()
            })
            .then((resp) => {
                let leadObj = resp.data.map((item: any) => {
                    item.label = item.vendorName;
                    item.value = item.idVendors;
                    return item
                })
                setVendors(leadObj);
            })
            .catch((error) => {
                console.log(error, 'catch the hoop')
            })
    }

    const getPurchaseInfo = () => {
        fetch(
            process.env.REACT_APP_API_URL + 'po/' + idPo + '/edit',
            getRequestOptions()
        )
            .then((resp) => {
                return resp.json()
            })
            .then((resp) => {
                const data = resp.data;
                
                const purchaseRes: PurchaseData = {
                    idPo: data.id_po,
                    purchaseType: data.purchaseType,
                    purpose: data.purpose || 'Raw Materials',
                    idProjects: data.id_projects,
                    idVendors: data.id_vendors,
                    purchaseDate: data.purchaseDate,
                    referenceNo: data.referenceNo,
                    lcNo: data.lcNo || '',
                    piNo: data.piNo || '',
                    representativeName: data.representativeName || '',
                    representativePhone: data.representativePhone || '',
                    receivingAddress: data.receivingAddress || '',
                    creditDays: data.creditDays || 0,
                    totalAmount: Number(data.totalAmount || 0),
                    totalDiscountAmount: Number(data.discountAmount || 0),
                    totalCarryingCost: Number(data.carryingCost || 0),
                    totalAmountAfterDiscount: Number(data.totalAmount || 0) - Number(data.discountAmount || 0) + Number(data.carryingCost || 0),
                    vatPercentage: Number(data.vat || 0),
                    vatAmount: Number(data.vatAmount || 0),
                    taxPercentage: Number(data.tax || 0),
                    taxAmount: Number(data.taxAmount || 0),
                    vatType: data.vatType === 'flat' ? 'flat' : 'percentage',
                    taxType: data.taxType === 'flat' ? 'flat' : 'percentage',
                    purchaseAmount: Number(data.purchaseAmount || 0)
                };
                
                setPurchase(purchaseRes);
                setProject({ label: data.project.projectName, value: data.id_projects });
                setVendor({ label: data.vendor.vendorName, value: data.id_vendors });
                
                // Map rows with all fields
                const rows = data.rows.map((item: any) => {
                    const excludingRate = Number(item.excluding_rate || item.rate || 0);
                    const quantity = Number(item.quantity || 0);
                    const discountAmount = Number(item.discount_amount || 0);
                    const carryingCost = Number(item.carrying_cost || 0);
                    const amount = excludingRate * quantity;
                    const totalAmount = amount - discountAmount + carryingCost;
                    const rate = quantity > 0 ? totalAmount / quantity : excludingRate;
                    const isFinishedProduct = (data.purpose || 'Raw Materials') === 'Finished Product';
                    const packingUnit = [item.product?.packing, item.product?.item?.unit?.unitName].filter(Boolean).join(' ');
                    
                    return {
                        idPoRows: item.id_po_rows,
                        idItems: item.id_items || 0,
                        idProducts: item.id_products || 0,
                        quantity: quantity,
                        excludingRate: excludingRate,
                        amount: amount,
                        discountAmount: discountAmount,
                        carryingCost: carryingCost,
                        totalAmount: totalAmount,
                        rate: rate,
                        itemName: isFinishedProduct
                            ? (item.product?.productName
                                ? (item.product.productCode
                                    ? `${item.product.productName}${packingUnit ? ' (' + packingUnit + ')' : ''} Code: ${item.product.productCode}`
                                    : `${item.product.productName}${packingUnit ? ' (' + packingUnit + ')' : ''}`)
                                : '')
                            : (item.item?.itemName || '')
                    };
                });
                // Set initial load flag to prevent useEffect from recalculating
                isInitialLoadRef.current = true;
                setPurchaseRows(rows);
                
                // Load terms and conditions
                if (data.terms && data.terms.length > 0) {
                    const terms = data.terms.map((term: any) => ({
                        termsConditionDetails: term.termsConditionDetails || ''
                    }));
                    setTermsAndConditions(terms);
                } else {
                    setTermsAndConditions([]);
                }
                
                // Reset flag after a short delay
                setTimeout(() => {
                    isInitialLoadRef.current = false;
                }, 200);
            })
            .catch((error) => {
                console.log(error, 'catch the hoop')
            })
    }

    const handleProjectChange = (project: any) => {
        setProject(project);
        const nextPurchase = { ...purchase, idProjects: project.value };
        setPurchase(nextPurchase);
        if (nextPurchase.purpose === 'Finished Product') {
            setPurchaseRows([{
                idPoRows: 0,
                idItems: 0,
                idProducts: 0,
                quantity: 0,
                excludingRate: 0,
                amount: 0,
                discountAmount: 0,
                carryingCost: 0,
                totalAmount: 0,
                rate: 0,
            }]);
        }
    }

    const handleVendorChange = (vendor: any) => {
        setVendor(vendor);
        setPurchase({ ...purchase, idVendors: vendor.value });
    }

    const handleInputOnChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setPurchase({ ...purchase, [event.target.name]: event.target.value });
    }

    const handleChargeChange = (charge: ChargeName, change: ChargeChange) => {
        setPurchase((prev) => applyChargeChange(prev, charge, change));
        setTimeout(() => {
            calculateSummary();
        }, 0);
    }

    const handleSelectOnChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
        const { id, value } = event.target;
        if (id === 'purchaseType' && value !== 'LC') {
            setPurchase({ ...purchase, purchaseType: value, lcNo: '', piNo: '' });
            return;
        }
        if (id === 'purpose') {
            setPurchase({ ...purchase, purpose: value });
            setPurchaseRows([{
                idPoRows: 0,
                idItems: 0,
                idProducts: 0,
                quantity: 0,
                excludingRate: 0,
                amount: 0,
                discountAmount: 0,
                carryingCost: 0,
                totalAmount: 0,
                rate: 0,
            }]);
            return;
        }
        setPurchase({ ...purchase, [id]: value });
    };

    const calculateSummary = () => {
        if (!purchaseRows.length) return;
        
        isCalculatingRef.current = true;
        
        let totalAmount = 0;
        let totalDiscountAmount = 0;
        let totalCarryingCost = 0;
        
        // Create updated rows array with calculated values
        const updatedRows = purchaseRows.map((row) => {
            const amount = Number(row.excludingRate || 0) * Number(row.quantity || 0);
            const discountAmount = Number(row.discountAmount || 0);
            const carryingCost = Number(row.carryingCost || 0);
            const rowTotalAmount = amount - discountAmount + carryingCost;
            const rate = row.quantity > 0 ? rowTotalAmount / row.quantity : Number(row.excludingRate || 0);
            
            totalAmount += amount;
            totalDiscountAmount += discountAmount;
            totalCarryingCost += carryingCost;
            
            return {
                ...row,
                amount: amount,
                discountAmount: discountAmount,
                carryingCost: carryingCost,
                totalAmount: rowTotalAmount,
                rate: rate
            };
        });

        // Update rows state with calculated values
        setPurchaseRows(updatedRows);

        // Update purchase summary
        setPurchase((prev) => {
            let totalAmountAfterDiscount = totalAmount - totalDiscountAmount + totalCarryingCost;
            let vatAmount = resolveChargeAmount(totalAmountAfterDiscount, prev.vatType, prev.vatPercentage, prev.vatAmount);
            let taxAmount = resolveChargeAmount(totalAmountAfterDiscount, prev.taxType, prev.taxPercentage, prev.taxAmount);
            let purchaseAmount = totalAmountAfterDiscount + vatAmount + taxAmount;

            return {
                ...prev,
                totalAmount: totalAmount,
                totalDiscountAmount: totalDiscountAmount,
                totalCarryingCost: totalCarryingCost,
                totalAmountAfterDiscount: totalAmountAfterDiscount,
                vatAmount: vatAmount,
                taxAmount: taxAmount,
                purchaseAmount: purchaseAmount
            };
        });
    };

    const numberFormat = (value: number) => {
        return parseFloat(value.toString()).toLocaleString('en-US', {
            style: 'decimal',
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        });
    }


    const deleteTermItem = (index: number) => {
        const updatedTermRows = [...termsAndConditions];
        if (updatedTermRows && updatedTermRows[index]) {
            updatedTermRows.splice(index, 1);
            setTermsAndConditions(updatedTermRows);
        }
    }

    const addTermItem = () => {
        const newTermRow: TermsAndCondition = {
            termsConditionDetails: '',
        };

        const updatedTermRows = [...termsAndConditions];
        updatedTermRows.push(newTermRow);

        setTermsAndConditions(updatedTermRows);
    }

    const handleTermsChange = (e: React.ChangeEvent<HTMLInputElement>, index: number) => {
        const updatedTermRows = [...termsAndConditions];
        updatedTermRows[index][e.target.name] = e.target.value;

        setTermsAndConditions(updatedTermRows);
    }

    const purchaseSave = async (event: any) => {
        event.preventDefault()

        setPurchase({ ...purchase });

        const confirm = await Swal.fire({
            title: 'Are you sure?',
            text: "You want to update this Purchase Order?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#ec008c',
            cancelButtonText: 'Cancel',
            confirmButtonText: 'Yes, Update it!',
        })
        if (confirm.value) {
            const postData = {
                purchase: { ...purchase, idPo: purchase.idPo },
                purchaseRows: purchaseRows.map(row => ({
                    idPoRows: row.idPoRows || null,
                    idItems: row.idItems,
                    idProducts: row.idProducts,
                    excludingRate: row.excludingRate,
                    quantity: row.quantity,
                    discountAmount: row.discountAmount,
                    carryingCost: row.carryingCost,
                    rate: row.rate
                })),
                customTermsConditions: termsAndConditions
            }
            const requestOptions = postRequestOptions(postData)
            try {
                let response = await fetch(
                    `${process.env.REACT_APP_API_URL}po/update`,
                    requestOptions
                )
                let respData = await response.json()
                if (respData.success === true) {
                    const successMsg = respData.successMessage
                    Swal.fire({
                        icon: 'success',
                        title: 'Success',
                        text: successMsg,
                    })

                    history.push("/po");
                } else {
                    // Check for errorMessage first (for validation errors from backend)
                    if (respData.errorMessage) {
                        Swal.fire({
                            icon: 'error',
                            title: respData.heading || 'Error',
                            text: respData.errorMessage,
                        })
                    } else if (respData.errors) {
                        // Fallback to validation errors if errorMessage is not present
                        const errorsMessage = validationErrorMsg(respData.errors).join('<br>')
                        Swal.fire({
                            icon: 'error',
                            title: 'Error',
                            html: errorsMessage,
                        })
                    } else {
                        Swal.fire({
                            icon: 'error',
                            title: 'Error',
                            text: 'Failed to update Purchase Order.',
                        })
                    }
                }

            } catch (error) {
                console.log(error, 'catch the hoop')
            }
        }
    }

    return (

        <div className="card card-custom">
            <div className="card-header">
                <div className="card-title">
                    <KTSVG
                        path='/media/svg/icons/Home/Book-open.svg'
                        className='svg-icon-1 svg-icon-primary'
                    />
                    <span className="text fw-bolder" style={{ marginLeft: "10px" }}>
                        Edit Purchase Order
                    </span>
                </div>
            </div>

            <div className="ml-12">
                <div className="card-body">

                    <form onSubmit={purchaseSave}>

                        <div className="form-group row">
                            <label htmlFor="purchaseType" className="col-lg-3 col-form-label" style={{ "textAlign": "right" }}>Purchase Type <span className="required text-danger"></span></label>
                            <div className="col-lg-5">
                                <select name="purchaseType" id="purchaseType" onChange={handleSelectOnChange} className="form-control form-control-sm" value={purchase.purchaseType}>
                                    <option value={'PO'}>PO</option>
                                    <option value={'LC'}>LC</option>
                                </select>
                            </div>
                        </div>
                        <div className="form-group row">
                            <label htmlFor="purpose" className="col-lg-3 col-form-label" style={{ "textAlign": "right" }}>Purpose <span className="required text-danger"></span></label>
                            <div className="col-lg-5">
                                <select name="purpose" id="purpose" onChange={handleSelectOnChange} className="form-control form-control-sm" value={purchase.purpose}>
                                    <option value={'Raw Materials'}>Raw Materials</option>
                                    <option value={'Finished Product'}>Finished Product</option>
                                </select>
                            </div>
                        </div>
                        <div className="form-group row">
                            <label htmlFor="idProjects" className="col-lg-3 col-form-label" style={{ "textAlign": "right" }}>Select Project <span className="required text-danger"></span></label>
                            <div className="col-lg-5">
                                <Select
                                    value={project}
                                    onChange={handleProjectChange}
                                    options={projects}
                                    menuPosition="fixed"
                                    styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                />
                            </div>
                        </div>
                        <div className="form-group row">
                            <label htmlFor="idVendors" className="col-lg-3 col-form-label" style={{ "textAlign": "right" }}>Select Vendor <span className="required text-danger"></span></label>
                            <div className="col-lg-5">
                                <Select
                                    value={vendor}
                                    onChange={handleVendorChange}
                                    options={vendors}
                                    menuPosition="fixed"
                                    styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                />
                            </div>
                        </div>
                        <div className="form-group row">
                            <label htmlFor="purchaseDate" className="col-lg-3 col-form-label" style={{ "textAlign": "right" }}>Purchase Date <span className="required text-danger"></span></label>
                            <div className="col-lg-5">
                                <input type='date' name="purchaseDate" id="purchaseDate" onChange={handleInputOnChange} className="form-control form-control-sm" value={purchase.purchaseDate} />
                            </div>
                        </div>
                        <div className="form-group row">
                            <label htmlFor="referenceNo" className="col-lg-3 col-form-label" style={{ "textAlign": "right" }}>Reference No</label>
                            <div className="col-lg-5">
                                <input type='text' name="referenceNo" id="referenceNo" onChange={handleInputOnChange} className="form-control form-control-sm" value={purchase.referenceNo} disabled />
                            </div>
                        </div>

                        {
                            purchase.purchaseType === 'LC' && (
                                <>
                                    <div className="form-group row">
                                        <label htmlFor="lcNo" className="col-lg-3 col-form-label" style={{ "textAlign": "right" }}>LC No <span className="required text-danger"></span></label>
                                        <div className="col-lg-5">
                                            <input name="lcNo" id="lcNo" value={purchase.lcNo} onChange={handleInputOnChange} className="form-control form-control-sm" readOnly />
                                            <span className="form-text text-muted">LC No cannot be changed after creation</span>
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <label htmlFor="piNo" className="col-lg-3 col-form-label" style={{ "textAlign": "right" }}>PI No <span className="required text-danger"></span></label>
                                        <div className="col-lg-5">
                                            <input name="piNo" id="piNo" value={purchase.piNo} onChange={handleInputOnChange} className="form-control form-control-sm" required={purchase.purchaseType === 'LC'} />
                                        </div>
                                    </div>
                                </>
                            )
                        }

                        <div className="form-group row mb-2">
                            <label htmlFor="representativeName" className="col-lg-3 col-form-label" style={{ "textAlign": "right" }}>Representative Name</label>
                            <div className="col-lg-5">
                                <input name="representativeName" id="representativeName" onChange={handleInputOnChange} className="form-control form-control-sm" value={purchase.representativeName} />
                            </div>
                        </div>
                        <div className="form-group row mb-2">
                            <label htmlFor="representativePhone" className="col-lg-3 col-form-label" style={{ "textAlign": "right" }}>Representative Number</label>
                            <div className="col-lg-5">
                                <input name="representativePhone" id="representativePhone" onChange={handleInputOnChange} className="form-control form-control-sm" value={purchase.representativePhone} />
                            </div>
                        </div>
                        <div className="form-group row mb-2">
                            <label htmlFor="receivingAddress" className="col-lg-3 col-form-label" style={{ "textAlign": "right" }}>Receiving Address</label>
                            <div className="col-lg-5">
                                <input name="receivingAddress" id="receivingAddress" onChange={handleInputOnChange} className="form-control form-control-sm" value={purchase.receivingAddress} />
                            </div>
                        </div>

                        <br></br>

                        <Accordion defaultActiveKey={['0', '1']} alwaysOpen>
                            <Accordion.Item eventKey="0">
                                <Accordion.Header>Purchase Items</Accordion.Header>
                                <Accordion.Body>
                                    <PurchaseOrderItemsSection
                                        purchase={purchase}
                                        purchaseRows={purchaseRows}
                                        setPurchaseRows={setPurchaseRows}
                                        onChargeChange={handleChargeChange}
                                        numberFormat={numberFormat}
                                    />
                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="1">
                                <Accordion.Header>Terms and Conditions and Additional Print Information</Accordion.Header>
                                <Accordion.Body>
                                    <div className="form-group row mb-2">
                                        <label htmlFor="creditDays" className="col-lg-3 col-form-label" style={{ "textAlign": "right" }}>Credit Days</label>
                                        <div className="col-lg-5">
                                            <input type='number' min={0} step={'any'} name="creditDays" id="creditDays" onChange={handleInputOnChange} className="form-control form-control-sm" value={purchase.creditDays} />
                                        </div>
                                    </div>
                                    <Table size='sm' bordered hover>
                                        <thead>
                                            <tr>
                                                <th style={{ width: '10%' }} className='text-center'>SL</th>
                                                <th style={{ width: '80%' }}>Terms & Condition <span className='text-danger'>*</span> </th>
                                                <th style={{ width: '10%' }}></th>
                                            </tr>
                                        </thead>

                                        <tbody>

                                            {termsAndConditions.map((row, index) => (
                                                <tr key={'terms-' + index}>
                                                    <td className='text-center'>{index + 1}</td>
                                                    <td>
                                                        <input type="text" name="termsConditionDetails" value={row.termsConditionDetails} className="form-control form-control-sm" onChange={(event) => handleTermsChange(event, index)} />
                                                    </td>
                                                    <td>
                                                        <button type='button' className="btn btn-light-primary btn-sm px-2 py-1" onClick={() => deleteTermItem(index)}>
                                                            <KTSVG path='/media/svg/icons/General/Trash.svg' className='svg-icon-5 svg-icon-danger me-0' />
                                                        </button>
                                                    </td>
                                                </tr>
                                            ))}
                                            {termsAndConditions.length === 0 && (
                                                <tr>
                                                    <td colSpan={3} className='text-center'>No terms and conditions added</td>
                                                </tr>
                                            )}
                                            <tr>
                                                <td colSpan={2} className='text-end'>
                                                    <button type='button' className="btn btn-success btn-sm px-2 py-1" onClick={() => addTermItem()}>
                                                        <KTSVG path='/media/svg/icons/Navigation/Plus.svg' className='svg-icon-5 svg-icon-danger me-0' /> Add
                                                    </button>
                                                </td>
                                            </tr>

                                        </tbody>

                                    </Table>
                                </Accordion.Body>
                            </Accordion.Item>
                        </Accordion>

                        <div className="row mt-4">
                            <div className="col-12 text-center">
                                <button type="submit" className="btn btn-sm btn-primary me-2">
                                    <span>  Update PO</span>
                                </button>
                                <Link to='/po' type="reset" className="btn btn-sm btn-secondary">Cancel</Link>
                            </div>
                        </div>
                                        
                    </form>

                </div>
            </div>
        </div>

    )
}

export default PurchaseOrderEdit
